import { useMemo } from 'react';
import { Stack, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Select from 'components/global/CUK/AsyncSelect/Select';
import { OptionMultiCount } from 'components/global/CUK/AsyncSelect/components/Option';
import { toast } from 'components/global/CUK/Toast/Toast'
import TextFilter from 'components/TextFilter'
import { useRegisterBreadcrumbAction } from 'components/AuthenticatedLayout/Header/components/BreadcrumbActions'
import HeaderExportButton from 'components/global/Buttons/HeaderExportButton'
import { useUser } from 'store'

import { useFilters, useSelection } from './store'
import { useCount, useExport } from './use-bypass'
import { trackEvent } from 'analytics'

const Export = () => {
  const {t} = useTranslation()
  const [user] = useUser()
  const {launch, loading} = useExport()

  const handleExport = async () => {
    trackEvent('bypass_export')
    try {
      const url = await launch()
      window.open(url, '_blank')
    } catch (e) {
      toast.error('actions.error')
      console.error(e)
    }
  }

  return (
    <HeaderExportButton
      analyticsName="bypass"
      disabled={Boolean(user?.demo_mode)}
      onClick={loading ? () => {} : handleExport}
      loading={loading}
    >
      {t('bypass.actions.export')}
    </HeaderExportButton>
  )

}

const Status = () => {
  const {t} = useTranslation()
  const [filters, setFilters] = useFilters()
  const {active, inactive} = useCount()
  const choices = [
    {
      label: t('bypass.filters.state.activated'),
      value: 'activated',
      id: 1
    },
    {
      label: t('bypass.filters.state.deactivated'),
      value: 'deactivated',
      id: 2
    }
  ]

  return (
    <Select
      /* @ts-expect-error JSX */
      isMulti={true}
      hideSelectedOptions={false}
      options={choices}
      mainField="label"
      placeholder={t('auth.admin.select_placeholder')}
      onChange={(values) => {
        const selectedStates = values.map(({value}) => value)
        setFilters(prev => ({...prev, state: selectedStates}))
        trackEvent('filter_changed', {
          filter_name: 'bypass_status',
          filter_value: selectedStates.sort().join(',') || 'none',
        })
      }}
      components={{
        Option: (props) => {
          const count = useMemo(() => {
            if (props.data.value === 'activated') { return active }
            else if (props.data.value === 'deactivated') { return inactive }
          }, [active, inactive]);
          return (
            <OptionMultiCount {...props} value={props.data} count={count} />
          );
        }
      }}
      value={choices.filter(
        (choice) => filters.state.findIndex(value => choice.value === value) > -1,
      )}
    />
  )
}
const Topbar = () => {
  const { t } = useTranslation()
  const [filters, setFilters] = useFilters()
  const [user] = useUser()
  const navigate = useNavigate()
  const [, setSelection] = useSelection()
  const exportAction = useMemo(() => <Export />, [])

  useRegisterBreadcrumbAction(exportAction)

  return (
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
      <Stack direction={'row'} gap={1}>
        <TextFilter
          value={filters.verbatim || ''}
          placeholder={t('bypass.filters.search')}
          onChange={value => {
            setFilters(prev => ({ ...prev, verbatim: value }))
          }}
        />
        <Status />
      </Stack>
      <Stack direction={'row'} gap={2}>
        <Button
          disabled={Boolean(user?.demo_mode)}
          size={'small'}
          variant={'contained'}
          onClick={() => {
            trackEvent('bypass_create')
            setSelection([])
            navigate('./new')
          }}>
          <i className={'fa-light fa-plus'} style={{ marginRight: '4px' }} />
          {t('bypass.actions.create')}
        </Button>
      </Stack>
    </Stack>
  )
}

export default Topbar
